import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { CircularProgress, FormControl } from '@material-ui/core';
import { TreeViewSelect } from '../../../../TreeViewSelect';
import type { TreeViewSelectNode } from '../../../../TreeViewSelect';
import { CreateRoleFormValues } from '../types';
import { FormFields, PlaceholderBox } from '../styles';

interface ContentsStepProps {
  control: Control<CreateRoleFormValues>;
  contentsTree: TreeViewSelectNode[];
  isLoadingContents: boolean;
}

export function ContentsStep({
  control,
  contentsTree,
  isLoadingContents,
}: ContentsStepProps) {
  if (isLoadingContents) {
    return (
      <PlaceholderBox>
        <CircularProgress size={32} />
      </PlaceholderBox>
    );
  }

  return (
    <FormControl component="fieldset" style={{ width: '100%' }}>
      <FormFields>
        <Controller
          name="contents"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TreeViewSelect
              id="create-role-contents"
              items={contentsTree}
              value={field.value || []}
              onChange={field.onChange}
              label="Contents"
              placeholder="Select roles and attributes..."
              required
              error={Boolean(error)}
              helperText={error?.message}
              disabled={contentsTree.length === 0}
            />
          )}
        />
      </FormFields>
    </FormControl>
  );
}
